import {createSlice} from "@reduxjs/toolkit";

// Defino valor inicial para el estado de mi slice
const initialState = {
	isOpen: false
}

// creo el slice con toda su configuración y sus acciones
const loadingSlice = createSlice({
	name: "loadingSlice",
	initialState,
	reducers: {
		hideLoadingScreen: (state) => {
			state.isOpen = false;
		},
		showLoadingScreen: (state) => {
			state.isOpen = true;
		},
	}
});

// Expongo las funcionalidades
export const {hideLoadingScreen, showLoadingScreen} = loadingSlice.actions;

export default loadingSlice.reducer;